var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "6 6 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4544 17.6849L22.7649 13.9953L25.4318 11.327L29.12 15.0152L26.4544 17.6849ZM16.9546 27.1943L12.879 27.5653L13.2404 23.5184L20.9303 15.8284L24.6213 19.5194L16.9546 27.1943ZM31.0887 13.1109L31.0873 13.1095L27.3388 9.36107C26.3244 8.34934 24.5816 8.30142 23.6205 9.2666L11.3046 21.5826C10.8583 22.0275 10.5817 22.6189 10.5242 23.2446L10.0053 28.9535C9.96974 29.3574 10.1135 29.7571 10.401 30.0446C10.6597 30.3034 11.0088 30.4458 11.3689 30.4458C11.4113 30.4458 11.4524 30.4444 11.4935 30.4403L17.2024 29.9214C17.8294 29.8639 18.4195 29.5887 18.8644 29.1438L31.1818 16.8265C32.1784 15.8271 32.136 14.1596 31.0887 13.1109V13.1109Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8935307c9d49178114bf8d836d5375f5.svg";
export { ForwardRef as ReactComponent };